"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferRatesByAreas = void 0;
const getTransferRatesByAreas = async (supabase, areas) => {
    const { data, error } = await supabase.rpc("get_transfer_rates_by_areas", {
        area_array: areas,
    });
    if (!error)
        return data;
    return error;
};
exports.getTransferRatesByAreas = getTransferRatesByAreas;
